import { motion } from "framer-motion";
import { ease } from "@/lib/scroll";

export const Reveal = ({ children, delay = 0, y = 36, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 1.1, delay, ease }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ n, children }) => (
  <div className="flex items-center gap-4 font-tt-mono text-[12px] uppercase tracking-[0.3em] text-[#D9B47A]">
    <span>{n}</span>
    <span className="w-10 h-px bg-[#D9B47A]/60" />
    <span>{children}</span>
  </div>
);
